import { environmentQueryKeys } from '@/react/portainer/environments/queries/query-keys';
import { RegistryId } from '@/react/portainer/registries/types/registry';

export const queryKeys = {
  base: () => ['addons'] as const,
  list: () => [...queryKeys.base(), 'list' as const],
  // switcher is a child of the full list key so the addon mutations, which
  // invalidate list(), also refresh the sidebar switcher (React Query prefix
  // match) — an install/enable/uninstall updates the launchable products.
  switcher: () => [...queryKeys.list(), 'switcher' as const],
  detail: (id: string) => [...queryKeys.base(), 'detail' as const, id],
  // Under the environments key, not addons, so every environment mutation
  // invalidates it. Otherwise React Query serves a stale "no environment"
  // after the admin connects the cluster.
  environment: () => [...environmentQueryKeys.base(), 'addon' as const],
  versions: (id: string) => [...queryKeys.base(), id, 'versions' as const],
  values: (id: string, version: string) => [
    ...queryKeys.base(),
    id,
    'values' as const,
    version,
  ],
  // Keyed by the manifest reference too: what a repository holds is read from one
  // of its tags, and a different tag is a different answer.
  repositoryKind: (
    registryId: RegistryId,
    repository: string,
    reference?: string
  ) => [
    ...queryKeys.base(),
    'repository-kind' as const,
    registryId,
    repository,
    reference,
  ],
  // Keyed by the chart source too, not the add-on alone: the install wizard
  // checks a registry and chart the user has picked but not yet installed, and
  // each pair is its own answer.
  chartSource: (id: string, registryId: RegistryId, chart: string) => [
    ...queryKeys.base(),
    id,
    'chart-source' as const,
    registryId,
    chart,
  ],
};
